<i18n>
{
	"en": {
		"title": "Order log",
		"type": "Type",
		"date": "Date",
		"driver": "Driver",
		"received": "Received",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"inbound": "Inbound",
		"outbound": "Outbound",
		"rejected": "Rejected",
		"unsuccessful": "Unsuccessful pickup",
		"requested": "Requested",
		"accepted": "Accepted"
	},
	"no": {
		"title": "Oppdragslogg",
		"type": "Type",
		"date": "Dato",
		"driver": "Sjåfør",
		"received": "Mottatt",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"inbound": "Inngående",
		"outbound": "Utgående",
		"rejected": "Avslått",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Godtatt"
	}
}
</i18n>
<template>
	<t-form-group>
		<t-grid
			v-if="ready"
			:items="orderEvents"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="40"
			:showFilters="false"
			:sort="[{field: 'date.date', direction: 'desc'}]"
			style="height: 400px; overflow-y:hidden;"
		>
			<template v-slot:icon="{ item }">
				<t-timpex-icon
					:icon="getIcon(item.type)"
					type="bp"
					color="blue"
					style="padding-left: 3px;"
				/>
			</template>
			<template v-slot:type="{ item }">
				{{$t(item.type)}}
			</template>
			<template v-slot:date="{ item }">
				{{getDate(item.date)}}
			</template>
		</t-grid>
	</t-form-group>
</template>

<script>
import moment from 'moment';
import { eventIcon } from '@/core';

export default {
	name: 'OrderLog',
	props: {
		ready: Boolean,
		orderEvents: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return { defaultColumnDefinition: { resizable: false, }, showGrid: false };
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'icon',
					displayName: '',
					width: 50,
				},
				{
					field: 'type',
					displayName: this.$t('type'),
					minWidth: 70,
					resizable: true,
				},
				{
					field: 'driver',
					displayName: this.$t('driver'),
					width: 150,
					type: 'number',
				},
				{
					field: 'date.date',
					displayName: this.$t('date'),
					width: 150,
					valueGetter: (item) => this.getDate(item.date.date),
					type: 'date',
					dateFormat: 'DD.MM.YYYY HH:mm',
					comparableValueGetter: (item) => moment(item.date.epoch).toISOString(),
				},
			];
		},
		orderNumber() {
			return this.order? this.order.orderNumber : '';
		}
	},
	methods: {
		onClose() {
			this.showGrid = false;
			this.$emit('close');
		},
		getIcon(type) {
			return eventIcon.getIcon(type);
		},
		getDate(date) {
			return moment(date, 'YYYYMMDDHHmm').format('DD.MM.YYYY HH:mm');
		}
	}
};
</script>
